import EEGSummaryBrain3D from 'components/molcules/N1SummaryReport/EEG/EEGSummaryBrain3d'
import EEGSummaryOpinion from 'components/molcules/N1SummaryReport/EEG/EEGSummaryOpnion'
import useStyles from 'components/molcules/N1SummaryReport/useStyles'
import React, {ReactNode} from 'react'
import {useTranslation} from 'react-i18next'

interface EEGSummaryProps {
  contourImage?: string
  threeDimensionImage: string
  total: number
  CustomerCard?: ReactNode
  isSummary?: boolean
}

export default function EEGSummary(props: EEGSummaryProps) {
  const {contourImage, threeDimensionImage, total, CustomerCard, isSummary} =
    props
  const classes = useStyles()
  const {t} = useTranslation()

  return (
    <div className={classes.root}>
      {CustomerCard && CustomerCard}
      <EEGSummaryBrain3D
        index={1}
        threeDimensionImage={threeDimensionImage}
        isSummary={isSummary}
      />
      <EEGSummaryOpinion
        index={2}
        score={total}
        contourImage={contourImage}
        isSummary={isSummary}
      />
      <div className='Warning'>{t('IEEGSummaryReportWarning')}</div>
    </div>
  )
}
